const features = [
  {
    icon: 'ri-time-line',
    title: '24小时全天候',
    desc: '365天×24小时不间断服务，深夜和凌晨一样快速响应，真正凌晨不打烊。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '专业认证团队',
    desc: '所有服务人员持证上岗，经过严格背景审查和专业技能考核，安全可靠。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速响应承诺',
    desc: '下单后平均3分钟响应，配送类服务最快20分钟上门，深夜不等待。',
  },
  {
    icon: 'ri-heart-line',
    title: '用心陪伴守护',
    desc: '不仅是服务，更是深夜的温暖陪伴。每一位客服都经过同理心培训，用心倾听。',
  },
];

export default function WhyUs() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-sm font-medium rounded-full mb-4">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            凌晨不打烊的四大承诺
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm md:text-base">
            我们深知凌晨需要帮助时的无助感，所以我们用行动兑现每一个承诺
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 border border-background-200/60 text-center group hover:border-primary-200/60 transition-all"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}